<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" title="Half Title">
<p class="hf"><span class="right_1" epub:type="pagebreak" id="page_xxi" title="xxi">CONAMARA <br/>CHRONICLES</span></p>
<p class="hf1">TALES FROM <br/>IORRAS <br/>AITHNEACH<span class="right_1" epub:type="pagebreak" id="page_xxii" title="xxii"></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780253063526_Halftitle01.vue?48e4e844